import { Grid, Button, ButtonGroup } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";  // Add this import
import "react-tabs/style/react-tabs.css";
import BatteryMetrics from "./charts/battery-metrics";
import PowerMetrics from "./charts/power-metrics";
import ErrorMetricsScatter from "./charts/error-metrics";
import TemperatureMetrics from "./charts/temperature-metrics";
import ChargeCycleMetrics from "./charts/charge-cycle-metrics";
import ShuntMetrics from "./charts/shunt-metrics";
import InverterMetrics from "./charts/inverter-metrics";
import CoulombMetrics from "./charts/coulomb-metrics";  
import CellMetrics from "./charts/cell-metrics";
const StoredChartTab = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const { emsName} = useSelector((state) => state);
  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  const getButtonStyle = (index) => ({
    backgroundColor: selectedTab === index ? "lightgreen" : "white",
    color: "black"
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <ButtonGroup variant="contained" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Button onClick={() => handleTabChange(0)} style={getButtonStyle(0)}>Battery</Button>
        <Button onClick={() => handleTabChange(1)} style={getButtonStyle(1)}>Power</Button>
        <Button onClick={() => handleTabChange(2)} style={getButtonStyle(2)}>Error</Button>
        <Button onClick={() => handleTabChange(3)} style={getButtonStyle(3)}>Temperature</Button>
        <Button onClick={() => handleTabChange(4)} style={getButtonStyle(4)}>Charge Cycle</Button>
        <Button onClick={() => handleTabChange(5)} style={getButtonStyle(5)}>Shunt</Button>
        <Button onClick={() => handleTabChange(6)} style={getButtonStyle(6)}>Inverter</Button>
        <Button onClick={() => handleTabChange(7)} style={getButtonStyle(7)}>Coulomb</Button>
        <Button onClick={() => handleTabChange(8)} style={getButtonStyle(8)}>Cell</Button>
      </ButtonGroup>
      {selectedTab === 0 && (
        <Grid>
          <BatteryMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 1 && (
        <Grid>
          <PowerMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 2 && (
        <Grid>
          <ErrorMetricsScatter emsName={emsName}/>
        </Grid>
      )}
      {selectedTab === 3 && (
        <Grid>
          <TemperatureMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 4 && (
        <Grid>
          <ChargeCycleMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 5 && (
        <Grid>
          <ShuntMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 6 && (
        <Grid>
         <InverterMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 7 && (
        <Grid>
         <CoulombMetrics emsName={emsName} />
        </Grid>
      )}
      {selectedTab === 8 && (
        <Grid>
         <CellMetrics emsName={emsName} />
        </Grid>
      )}
    </div>
  );
};

export default StoredChartTab;
